import { ETHERSCAN_URL } from '#src/config.ts';

export const txLink = (txHash: string) => `${ETHERSCAN_URL}/tx/${txHash}`;

export const tokenLink = (contractAddress: string, tokenId: string) =>
  `${ETHERSCAN_URL}/token/${contractAddress}?a=${tokenId}`;
